import {
  Card,
  CardContent,
  Stack,
  Avatar,
  Box,
  Typography,
  Chip,
  Divider,
  Button,
} from "@mui/material";
import { useAppDispatch } from "../../hooks/hooks";
import {
  setSelectedLoanPool,
  setCurrentLoanPoolView,
} from "../../redux/uiSlice";
import { LoanPool } from "../../types/loanTypes";
import CowIcon from "../CowIcon";
import StatItem from "./StatItem";

const PoolListItem: React.FC<{
  pool: LoanPool;

  isMobile: boolean;
}> = ({ pool, isMobile }) => {
  const dispatch = useAppDispatch();

  return (
    <Card sx={{ mb: 2, borderRadius: 2 }}>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 1 }}>
          <Avatar sx={{ bgcolor: "primary.main" }}>
            <CowIcon fill="#fff" />
          </Avatar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">{pool.name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {pool.activeLoans} active loans
            </Typography>
          </Box>
          <Chip
            label={`${pool.avgInterest}% avg`}
            size="small"
            color="primary"
          />
        </Stack>

        <Divider sx={{ my: 1 }} />

        <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 2 }}>
          <StatItem label="Total Value" value={`${pool.totalValue} AGD`} />
          <StatItem label="Default Rate" value={`${pool.defaultRate}%`} />
        </Stack>

        <Button
          fullWidth
          variant="contained"
          size={isMobile ? "small" : "medium"}
          onClick={() => {
            console.log("Investing in pool:", pool.name);
            dispatch(setSelectedLoanPool(pool));
            dispatch(setCurrentLoanPoolView("invest-detail"));
          }}
        >
          Invest in Pool
        </Button>
      </CardContent>
    </Card>
  );
};

export default PoolListItem;
